export const COMPANY_BRAND_NAME = 'MAIA';
export const COMPANY_TAGLINE = 'Tecnologia para agentes de IA';

export const APP_NAME = 'Agent Forge';
export const APP_TAGLINE = 'Agent Studio';

/** Marca pública (landpage / chrome de marketing). */
export const MARKETING_NAME = COMPANY_BRAND_NAME;
export const MARKETING_TAGLINE = 'Mentoria digital no WhatsApp';

export const DEMO_EMAIL_SUBJECT = 'Quero conhecer a mentoria digital da MAIA';
